import React, { useCallback, useEffect, useState } from 'react';
import { connect } from 'react-redux';
import { debounce } from 'lodash';
import { Card, Row, Col } from 'react-bootstrap-5';

import { findListing } from 'bundles/connect/helpers/prospect_api';

import OverlayCard from './overlay_card';
import ResultSummary from '../results/result_summary';
import DisclosureCaption from 'components/photos/disclosure_caption';
import { type ExclusiveListing } from 'bundles/connect/types';

type ConnectListingOverlayCardProps = {
  hoverSaleListingId: number;
}

function ConnectListingOverlayCard({ hoverSaleListingId }: ConnectListingOverlayCardProps) {
  const [listing, setListing] = useState<ExclusiveListing | undefined>();

  const fetchListing = useCallback(
    debounce((id) => {
      findListing(id).then(setListing);
    }, 500),
    []
  );

  useEffect(() => {
    if (hoverSaleListingId && hoverSaleListingId !== listing?.saleListingId) {
      fetchListing(hoverSaleListingId);
    }
  }, [hoverSaleListingId]);

  if (!hoverSaleListingId || !listing || hoverSaleListingId !== listing.saleListingId) return null;

  return (
    <OverlayCard heightOffset={30} lat={listing.location.lat} lng={listing.location.lng}>
      <Row className="g-0" style={{ maxWidth: '320px' }}>
        <Col>
          <Card.Body className="p-2">
            <ResultSummary property={listing} />
          </Card.Body>
        </Col>
        <Col className="position-relative" xs={4}>
          <img
            className="rounded-end w-100 h-100"
            src={listing.thumbnail}
            style={{ objectFit: 'cover' }}
          />
          {listing.digitallyAltered && <DisclosureCaption compact />}
        </Col>
      </Row>
    </OverlayCard>
  );
}

const mapStateToProps = ({ ui: { hoverSaleListingId } }) => ({ hoverSaleListingId });

export default connect(mapStateToProps)(ConnectListingOverlayCard);
